import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import { useNavigate } from "react-router-dom";

const ViewMedia = () => {
  const [mediaList, setMediaList] = useState([]);
  const [selectedMedia, setSelectedMedia] = useState([]);
  const [isBtnEnabled, setIsBtnEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectAllImageChecked, setSelectAllImageChecked] = useState(false);
  const [selectAllVideoChecked, setSelectAllVideoChecked] = useState(false);
  const [selectAllMediaChecked, setSelectAllMediaChecked] = useState(false);
  const navigate = useNavigate();
  const token = config.token;

  // image SelectAll
  const handleSelectAllImageChange = (event) => {
    setSelectAllVideoChecked(false);
    setSelectAllMediaChecked(false);
    const isChecked = event.target.checked;
    setSelectAllImageChecked(isChecked);

    if (isChecked) {
      const allImageIds = images.map((media) => media.media_id);
      setSelectedMedia(allImageIds);
      setIsBtnEnabled(true);
    } else {
      setSelectedMedia([]);
      setIsBtnEnabled(false);
    }
  };

  // video SelectAll
  const handleSelectAllVideoChange = (event) => {
    setSelectAllImageChecked(false);
    setSelectAllMediaChecked(false);
    const isChecked = event.target.checked;
    setSelectAllVideoChecked(isChecked);

    if (isChecked) {
      const allVideoIds = videos.map((media) => media.media_id);
      setSelectedMedia(allVideoIds);
      setIsBtnEnabled(true);
    } else {
      setSelectedMedia([]);
      setIsBtnEnabled(false);
    }
  };

  //media SelectAll
  const handleSelectAllMediaChange = (event) => {
    setSelectAllImageChecked(false);
    setSelectAllVideoChecked(false);
    const isChecked = event.target.checked;
    setSelectAllMediaChecked(isChecked);

    if (isChecked) {
      const allMediaIds = other.map((media) => media.media_id);
      setSelectedMedia(allMediaIds);
      setIsBtnEnabled(true);
    } else {
      setSelectedMedia([]);
      setIsBtnEnabled(false);
    }
  };

  const handleCheckboxChange = (mediaId) => {
    setSelectedMedia((prevSelectedMedia) => {
      const updatedMedia = prevSelectedMedia.includes(mediaId)
        ? prevSelectedMedia.filter((id) => id !== mediaId)
        : [...prevSelectedMedia, mediaId];
      setIsBtnEnabled(updatedMedia.length > 0);
      return updatedMedia;
    });
  };

  const getMedia = () => {
    setLoading(true);
    fetch(`${config.host_url}media`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setMediaList(data.data);
          console.log(data.data);
        } else if (data.status === 401) {
          console.error("Invalid token");
        } else {
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching media:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getMedia();
  }, [token]);

  const showDeleteConfirmation = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete media files. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete them!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete();
      }
    });
  };

  const handleDelete = async () => {
    try {
      await fetch(`${config.host_url}media/bin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify({ ids: selectedMedia }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(async function (data) {
          if (data.status === 200) {
            triggerNotification("success", "Media deleted successfully");
            setSelectedMedia([]);
            setIsBtnEnabled(false);
            getMedia();
          } else if (data.status === 404) {
            console.error("Media IDs not found");
            triggerNotification("error", "Media IDs not found");
          } else if (data.status === 401) {
            console.error("Invalid token");
            triggerNotification("error", "Unauthenticated User");
          } else {
            console.error("Internal server error");
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      console.error("Error deleting media:", error);
      triggerNotification("error", "Error deleting media");
    }
  };

  const rows = [];
  for (let i = 0; i < mediaList.length; i += 6) {
    rows.push(mediaList.slice(i, i + 6));
  }

  const videos = mediaList.filter((media) => media.media_type === "video");
  const images = mediaList.filter((media) => media.media_type === "image");
  const other = mediaList.filter(
    (media) => media.media_type !== "image" && media.media_type !== "video"
  );

  return (
    <>
      <Breadcrumb txt="Manage Media" subpath={["View Media"]} />

      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Media</h5>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                navigate("/addmedia");
              }}
            >
              Add Media
            </button>
          </div>
          <div className="card-body">
            {loading ? (
              <Spinner />
            ) : mediaList.length === 0 ? (
              <p className="text-center">You don't have any media files.</p>
            ) : (
              <>
                {/* videos */}
                {videos.length > 0 && (
                  <div className="border rounded p-3 mb-3">
                    <div className="flex justify-between">
                      <h5 className="mb-3">Videos</h5>
                      <div className="border-none mx-2 mb-2  select-none flex justify-end">
                        <input
                          className=" mr-2 mb-1"
                          type="checkbox"
                          value=""
                          id="customCheckboxSelectAllVideo"
                          onChange={handleSelectAllVideoChange}
                          checked={selectAllVideoChecked}
                        />
                        <label
                          className={`${
                            selectAllVideoChecked && "text-green-600"
                          }`}
                          htmlFor="customCheckboxSelectAllVideo"
                        >
                          <span className="custom-option-body">
                            Select All Videos
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="row mb-3">
                      {videos.map((media) => (
                        <div className="col-md-2 mb-2" key={media.media_id}>
                          <div className="border-none  form-check custom-option custom-option-image custom-option-image-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id={`customCheckboxVideo${media.media_id}`}
                              onChange={() => {
                                handleCheckboxChange(media.media_id);
                                setSelectAllVideoChecked(false);
                              }}
                              checked={selectedMedia.includes(media.media_id)}
                            />
                            <label
                              className="form-check-label custom-option-content"
                              htmlFor={`customCheckboxVideo${media.media_id}`}
                            >
                              <div className="custom-option-body h-[128px]">
                                <video className="object-cover w-full h-full rounded">
                                  <source
                                    src={media.media_name}
                                    type="video/mp4"
                                  />
                                </video>
                              </div>
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {/* image */}
                {images.length > 0 && (
                  <div className="border rounded p-3 mb-3">
                    <div className="flex justify-between">
                      <h5 className="mb-3">Images</h5>
                      <div className="border-none mx-2 mb-2 select-none flex justify-end">
                        <input
                          className=" mr-2 mb-1"
                          type="checkbox"
                          value=""
                          id="customCheckboxSelectAll"
                          onChange={handleSelectAllImageChange}
                          checked={selectAllImageChecked}
                        />
                        <label
                          className={`${
                            selectAllImageChecked && "text-green-600"
                          }`}
                          htmlFor="customCheckboxSelectAll"
                        >
                          <span className="custom-option-body ">
                            Select All Images
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="row mb-3">
                      {images.map((media) => (
                        <div className="col-md-2 mb-2" key={media.media_id}>
                          <div className="border-none form-check custom-option custom-option-image custom-option-image-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id={`customCheckboxImg${media.media_id}`}
                              onChange={() => {
                                handleCheckboxChange(media.media_id);
                                setSelectAllImageChecked(false);
                              }}
                              checked={selectedMedia.includes(media.media_id)}
                            />
                            <label
                              className="form-check-label custom-option-content"
                              htmlFor={`customCheckboxImg${media.media_id}`}
                            >
                              <div className="custom-option-body h-[128px] ">
                                <img
                                  src={media.media_name}
                                  alt={`cbImg${media.media_id}`}
                                />
                              </div>
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {/* other files */}
                {other.length > 0 && (
                  <div className="border rounded p-3">
                    <div className="flex justify-between">
                      <h5 className="mb-3">Other Files</h5>
                      <div className="border-none mx-2 mb-2 select-none flex justify-end">
                        <input
                          className=" mr-2 mb-1"
                          type="checkbox"
                          value=""
                          id="customCheckboxSelectAllMedia"
                          onChange={handleSelectAllMediaChange}
                          checked={selectAllMediaChecked}
                        />
                        <label
                          className={`${
                            selectAllMediaChecked && "text-green-600"
                          }`}
                          htmlFor="customCheckboxSelectAllMedia"
                        >
                          <span className="custom-option-body ">
                            Select All Other Files
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="row mb-3">
                      {other.map((media) => (
                        <div className="col-md-3" key={media.media_id}>
                          <div className="form-check custom-option custom-option-image custom-option-image-check">
                            <label
                              className="form-check-label custom-option-content"
                              htmlFor={`customCheckboxOther${media.media_id}`}
                            >
                              <div className="flex">
                                <div className="">
                                  <div
                                    type="text"
                                    className="p-1 border-r-2 border-gray-200"
                                    style={{ height: "100%", display: "flex" }}
                                  >
                                    <span className="mdi mdi-file-document my-auto"></span>
                                  </div>
                                </div>

                                <div className="form-floating-outline w-full overflow-hidden whitespace-no-wrap ml-1 ">
                                  <div
                                    type="text"
                                    className=" pr-1"
                                    style={{
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <div className="">
                                      <span className="block overflow-hidden line-clamp-1">
                                        {media.media_name
                                          .split("/")
                                          .pop()
                                          .split(".")[0]
                                          .split("-")
                                          .pop()}
                                      </span>
                                    </div>

                                    <hr className="p-0 m-0" />
                                    <span className="block overflow-hidden line-clamp-1">
                                      {
                                        media.media_name.split(".")[
                                          media.media_name.split(".").length - 1
                                        ]
                                      }
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </label>

                            <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id={`customCheckboxOther${media.media_id}`}
                              onChange={() => {
                                handleCheckboxChange(media.media_id);
                                setSelectAllMediaChecked(false);
                              }}
                              checked={selectedMedia.includes(media.media_id)}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div className="flex justify-end">
            {isBtnEnabled && (
              <button
                type="button"
                className="text-red-700 hover:text-white border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-5 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                onClick={showDeleteConfirmation}
              >
                Delete
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewMedia;
